import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  TextField,
  Typography
} from '@mui/material'
import { Formik } from 'formik'
import React from 'react'
import * as Yup from 'yup'
import ButtonRow from '../../../utils/ui_components/buttonRow'
import { Close } from '@mui/icons-material'

function PaymentDailog({
  showpopDialog,
  tbpAmount,
  closeWindow,
  onSubmit,
  paymentValues
}) {
  const handleSubmit = (values) => {
    onSubmit(values)
  }
  const validationSchema = Yup.object().shape({
    amount: Yup.number()
      .max(
        paymentValues?.balance - tbpAmount,
        'Amount should not be greater than payable amount'
      )
      .min(1, 'Min Rs 1 is required')
      .required('Amount is required')
  })

  return (
    <>
      <Dialog
        maxWidth="xs"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        open={showpopDialog}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          Credit Payment
          <IconButton
            component="span"
            size="small"
            sx={{ ':hover': { backgroundColor: 'red', color: 'white' } }}
            onClick={closeWindow}
            variant="contained"
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <Divider flexItem />
        <DialogContent>
          <Grid container direction={'column'}>
            <Grid item>
              <Typography variant="subtitle" gutterBottom>
                Payable Amount:{' '}
              </Typography>
              <Typography color={'primary'} variant="subtitle" display="inline">
                {(paymentValues?.balance - tbpAmount).toFixed(2)}
              </Typography>
            </Grid>
            <Grid item>
              <Formik
                initialValues={{
                  amount: ''
                }}
                onSubmit={handleSubmit}
                validationSchema={validationSchema}
              >
                {({
                  values,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  touched,
                  errors
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Grid container direction={'column'}>
                      <Grid item sm>
                        <TextField
                          fullWidth
                          margin="normal"
                          name="amount"
                          label="Amount"
                          value={values.amount}
                          error={Boolean(touched.amount && errors.amount)}
                          helperText={touched.amount && errors.amount}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          my={2}
                        />
                      </Grid>
                      <Grid item>
                        <TextField
                          fullWidth
                          margin="normal"
                          name="remarks"
                          label="Remarks"
                          value={values.remarks}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          my={2}
                        />
                      </Grid>
                    </Grid>
                    <ButtonRow
                      button1Label={'Pay'}
                      button1Callback={handleSubmit}
                      button1Color={'success'}
                      button1Sx={{
                        ':hover': {
                          backgroundColor: 'green',
                          color: '#fff'
                        }
                      }}
                    />
                  </form>
                )}
              </Formik>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default PaymentDailog
